/**
 * Top 20 Most Popular Stock Tickers
 *
 * These tickers are pre-cached twice daily (12-hour cache) via cron job for instant loading.
 * Based on market cap, trading volume, and user interest.
 *
 * Stock events and intelligent outlooks for these tickers are fetched proactively at 6 AM and 6 PM UTC.
 */

export interface TickerInfo {
  ticker: string;
  name: string;
}

export const TOP_20_TICKERS: TickerInfo[] = [
  // Top 10 (Tech Giants)
  { ticker: 'AAPL', name: 'Apple Inc.' },
  { ticker: 'MSFT', name: 'Microsoft Corporation' },
  { ticker: 'GOOGL', name: 'Alphabet Inc.' },
  { ticker: 'AMZN', name: 'Amazon.com Inc.' },
  { ticker: 'TSLA', name: 'Tesla Inc.' },
  { ticker: 'NVDA', name: 'NVIDIA Corporation' },
  { ticker: 'META', name: 'Meta Platforms Inc.' },
  { ticker: 'NFLX', name: 'Netflix Inc.' },
  { ticker: 'AMD', name: 'Advanced Micro Devices Inc.' },
  { ticker: 'INTC', name: 'Intel Corporation' },

  // Next 10 (Diversified)
  { ticker: 'BRK.B', name: 'Berkshire Hathaway Inc.' },
  { ticker: 'JPM', name: 'JPMorgan Chase & Co.' },
  { ticker: 'V', name: 'Visa Inc.' },
  { ticker: 'JNJ', name: 'Johnson & Johnson' },
  { ticker: 'WMT', name: 'Walmart Inc.' },
  { ticker: 'PG', name: 'Procter & Gamble Co.' },
  { ticker: 'UNH', name: 'UnitedHealth Group Inc.' },
  { ticker: 'MA', name: 'Mastercard Inc.' },
  { ticker: 'DIS', name: 'The Walt Disney Company' },
  { ticker: 'BAC', name: 'Bank of America Corp.' },
];

/**
 * Helper to check if a ticker is in the pre-cached top 20
 */
export const isTopTicker = (ticker: string): boolean => {
  return TOP_20_TICKERS.some(t => t.ticker.toUpperCase() === ticker.toUpperCase());
};

/**
 * Get company name for a ticker from the top 20 list
 */
export const getCompanyName = (ticker: string): string | null => {
  const match = TOP_20_TICKERS.find(t => t.ticker.toUpperCase() === ticker.toUpperCase());
  return match?.name || null;
};
